import { ThematicLayer } from "../layers/server/ThematicLayer";
import { Maybe, None } from "../../lib/misc/option";
export class OverlayLayerBox {
    constructor(opts) {
        this.initialized = false;
        this.layers = [];
        this._dragging = None.instance();
        this._dragged_over = None.instance();
        this.header = $();
        this.body = $();
        this.render_index = opts.render_index;
        this.ui_index = opts.ui_index;
        this.filter = l => !l.is_base && !(l instanceof ThematicLayer);
    }
    add_layers(layers) {
        this.layers = layers.filter(this.filter);
        this.build_ui();
    }
    set_dragging(e) {
        this._dragging = Maybe(e.data.layer);
    }
    set_dragged_over(e) {
        e.preventDefault();
        this._dragged_over = Maybe(e.data.layer);
    }
    reorder(_e) {
        if (this._dragging.isNone() || this._dragged_over.isNone())
            return;
        let priors = this.layers;
        let idx1 = priors.indexOf(this._dragging.unwrap());
        let idx2 = priors.indexOf(this._dragged_over.unwrap());
        let zs = priors.map(layer => layer.raw.map(l => l.getZIndex()).unwrapOr(0));
        priors.splice(idx1, 1);
        priors.splice(idx2, 0, this._dragging.unwrap());
        priors.forEach((layer, idx) => layer.raw.map(l => l.setZIndex(zs[idx])));
        this.build_ui();
    }
    build_ui() {
        if (!this.initialized) {
            this.header = $('<div class="header">Overlays</div><hr class="layerbox-hr" />');
            this.body = $('<div class="layerType overlay"></div>');
        }
        this.body.children().detach();
        this.layers.forEach(layer => {
            if (layer.ui.isNone()) {
                return;
            }
            const node = layer.ui.unwrapOr($());
            if (node) {
                node.get(0).draggable = true;
                node.on('drag', { layer: layer }, (e) => this.set_dragging(e));
                node.on('dragover', { layer: layer }, (e) => this.set_dragged_over(e));
                node.on('drop', { layer: layer }, (e) => this.reorder(e));
                this.body.append(node);
            }
        });
        this.initialized = true;
    }
}
